import Header from 'components/headers/wallet'
import useSetDoGroupPay from './hooks/useSetDoGroupPay'
import { useNavigate, useParams } from 'react-router-dom'
import classNames from 'classnames'

export default function GatewayCallback() {
    const navigate = useNavigate()
    const items = JSON.parse(localStorage.getItem('toBePaidTransactions')!)
    const { data, isLoading, refetch } = useSetDoGroupPay(items?.data)
    const { state } = useParams()
    return (
        <div className=" min-h-screen relative">
            <Header title="پرداخت آسان" />
            <p className=" mx-3 my-4">موارد در حال پرداخت:</p>
            {state &&
            //@ts-ignore
            state?.isWalletCharged ? (
                <div className=" my-4 rounded-lg py-3 px-4 text-center mx-4 bg-green-main shadow-[rgba(0,_0,_0,_0.24)_0px_3px_8px]">
                    <p className=" text-center text-green-1">
                        کیف پول شما برای پرداخت موارد زیر شارژ شد.
                    </p>
                </div>
            ) : (
                <></>
            )}
            {!isLoading && items ? (
                <>
                    {items.data.map((item) => (
                        <div
                            className={classNames(
                                'rounded-lg py-3 px-3 mx-3 my-3',
                                data
                                    ? ' border-1 border-green-1'
                                    : ' border-1 border-red-1 '
                            )}
                        >
                            <div className=" flex justify-between">
                                <p>{item.box_name}</p>
                                <div
                                    className={classNames(
                                        ' py-0.5 px-2  rounded-md',
                                        data
                                            ? 'bg-[#E7F8F3] text-[#13BF86]'
                                            : 'bg-[#FFEDED] text-[#FF4D4C]'
                                    )}
                                >
                                    {data ? 'پرداخت شد' : 'پرداخت ناموفق'}
                                </div>
                            </div>
                            <div className=" flex justify-between my-2">
                                <p className=" text-xs w-full">
                                    {item.description}
                                </p>
                                <p className=" w-full text-left">
                                    {item.amount &&
                                        Number(
                                            item.amount
                                        ).toLocaleString()}{' '}
                                    تومان
                                </p>
                            </div>
                        </div>
                    ))}
                    <div className="absolute  bottom-4 w-[90%] right-[5%]">
                        {!data && (
                            <p
                                className=" text-[#3399FF] text-center my-3"
                                onClick={() => refetch()}
                            >
                                {' '}
                                دوباره تلاش کنید
                            </p>
                        )}
                        <button
                            className={classNames(
                                ' bg-white  rounded-lg  py-3 w-full',
                                data
                                    ? 'text-green-1 border-1 border-green-1'
                                    : ' border-1 border-[#A5ADB8] text-[#A5ADB8]'
                            )}
                            onClick={() => {
                                localStorage.removeItem('toBePaidTransactions')
                                navigate('/funds')
                            }}
                        >
                            بازگشت
                        </button>
                    </div>
                </>
            ) : (
                <>
                    {items &&
                        items.data &&
                        items.data.map((item) => (
                            <div
                                className={classNames(
                                    'rounded-lg py-3 px-3 mx-3 my-3 border-1 border-[#D99711]'
                                )}
                            >
                                <div className=" flex justify-between">
                                    <p>{item.box_name}</p>
                                    <div
                                        className={classNames(
                                            ' py-0.5 px-2  rounded-md bg-[#FFF7E7] text-[#D99711]'
                                        )}
                                    >
                                        درحال پرداخت
                                    </div>
                                </div>
                                <div className=" flex justify-between my-2">
                                    <p className=" text-xs w-full">
                                        {item.description}
                                    </p>
                                    <p className=" w-full text-left">
                                        {item.amount &&
                                            Number(
                                                item.amount
                                            ).toLocaleString()}{' '}
                                        تومان
                                    </p>
                                </div>
                            </div>
                        ))}
                </>
            )}
        </div>
    )
}
